import * as React from 'react';

import { IAuthService } from '../../services/Interfaces/IAuthService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CountryCodeEnum } from '../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { NotificationType, UserNotification } from '../../interfaces/UserNotificationsUpdate';

export interface ExternalCaseMessageNotificationProps {
  onClick?: () => void;
}

type CaseMessageNotificationProps = { appState: AppState } & typeof AppActionCreators &
  ExternalCaseMessageNotificationProps &
  RouteComponentProps;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICaseMessageNotificationState {}

class CaseMessageNotification extends React.PureComponent<
  CaseMessageNotificationProps,
  ICaseMessageNotificationState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appUserService!: IAppUserService;
  private notifications: UserNotification[] = [];

  static contextType = ApplicationContext;

  state = {} as ICaseMessageNotificationState;

  onClick = async (notificationId: number, caseId: number) => {
    try {
      await this.handleCheck(notificationId);

      const currentPath = this.props.history.location.pathname.toLowerCase();
      this.props.history.push('/cases/' + caseId);

      if (currentPath.indexOf('/cases/') !== -1) {
        this.props.history.go(0);
      }
      if (this.props.onClick !== undefined) {
        this.props.onClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleCheck = async (notificationId: number) => {
    try {
      await this.caseService.ReadUserNotification(notificationId);
      await this.caseService.DeleteUserNotification(notificationId);
      this.props.RemoveNotification(notificationId);
    } catch (ex) {
      console.log(ex);
    }
  };

  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.notifications = this.props.appState.userNotifications.filter((notification: UserNotification) => notification.type === NotificationType.Comment);

    return (
      <React.Fragment>
        {this.notifications.length === 0 ? (
        <div className="text-center">
          <div className="avatar-icon-wrapper  m-0">
            <div className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper  m-0 d-140">
              <FontAwesomeIcon
                icon={['far', 'comment-dots']}
                className="d-flex align-self-center display-1 "
              />
            </div>
          </div>
        </div>
      ) : null}
        {this.notifications.length !== 0 ? (
          <List>
            {this.notifications.map((item, index) => (
              <ListItem divider key={index}>
                <Grid container direction="column">
                  <Grid item container spacing={1}>
                    <Grid item xs={3}>
                      <Button
                        color="primary"
                        className="text-primary justify-content-start p-0"
                        onClick={(e) => this.onClick(item.id, item.details.caseId)}
                      >
                        {item.details.caseId}
                      </Button>
                      <div>{item.details.statusDisplayName}</div>
                    </Grid>

                    <Grid item xs={8}>
                      <div>
                        {isNullOrUndefined(item.details.userName)
                          ? ''
                          : item.details.userName +
                            ' (' +
                            item.details.userHoName +
                            ')'}
                      </div>
                      <div className="font-size-sm text-black-50">
                        {moment
                          .utc(item.dateCreation)
                          .local()
                          .format(this.props.appState.longDateFormat)}
                      </div>
                    </Grid>
                    <Grid item container direction="column" xs={1}>
                      
                    </Grid>
                  </Grid>
                  <Grid item container spacing={1}>
                    <Grid item xs={11}>
                      <div className="font-size-sm text-black-50">
                        {item.details.text}
                      </div>
                    </Grid>
                    <Grid item container direction="column" xs={1}>
                      <IconButton
                        aria-label="delete"
                        color="inherit"
                        className="text-danger"
                        size="small"                        
                        onClick={(e) => {
                          this.handleCheck(item.id);
                        }}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </List>
        ) : null}
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalCaseMessageNotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(CaseMessageNotification as any));
